import React from 'react';
import { User, CreditCard, DollarSign, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { formatCurrency } from '../utils/mortgageCalculations';
interface ClientProfileProps {
  client: {
    name: string;
    ficoScore: number;
    monthlyIncome: number;
    monthlyDebts: number;
    existingLoans: number;
  };
}
export function ClientProfilePanel({
  client
}: ClientProfileProps) {
  const getFicoColor = (score: number) => {
    if (score >= 740) return 'success';
    if (score >= 670) return 'default';
    if (score >= 580) return 'warning';
    return 'destructive';
  };
  return <Card className="mb-6 bg-slate-50 border-slate-200" data-id="element-12">
      <CardContent className="p-4" data-id="element-13">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-14">
          <div className="flex items-center gap-3" data-id="element-15">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-16">
              <User className="h-5 w-5" data-id="element-17" />
            </div>
            <div data-id="element-18">
              <h2 className="text-lg font-semibold text-slate-900" data-id="element-19">
                {client.name}
              </h2>
              <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-20">
                <span data-id="element-21">Client ID: #84920</span>
                <span className="h-1 w-1 rounded-full bg-slate-300" data-id="element-22"></span>
                <span data-id="element-23">Active Opportunity</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 w-full md:w-auto" data-id="element-24">
            <div className="flex flex-col" data-id="element-25">
              <span className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-26">
                FICO Score
              </span>
              <div className="flex items-center gap-2" data-id="element-27">
                <TrendingUp className="h-4 w-4 text-slate-400" data-id="element-28" />
                <span className="font-bold text-slate-900" data-id="element-29">
                  {client.ficoScore}
                </span>
                <Badge variant={getFicoColor(client.ficoScore)} className="text-[10px] px-1.5 py-0 h-5" data-id="element-30">
                  {client.ficoScore >= 740 ? 'Excellent' : client.ficoScore >= 670 ? 'Good' : 'Fair'}
                </Badge>
              </div>
            </div>

            <div className="flex flex-col" data-id="element-31">
              <span className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-32">
                Monthly Income
              </span>
              <div className="flex items-center gap-2" data-id="element-33">
                <DollarSign className="h-4 w-4 text-slate-400" data-id="element-34" />
                <span className="font-bold text-slate-900" data-id="element-35">
                  {formatCurrency(client.monthlyIncome)}
                </span>
              </div>
            </div>

            <div className="flex flex-col" data-id="element-36">
              <span className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-37">
                Monthly Debts
              </span>
              <div className="flex items-center gap-2" data-id="element-38">
                <CreditCard className="h-4 w-4 text-slate-400" data-id="element-39" />
                <span className="font-bold text-slate-900" data-id="element-40">
                  {formatCurrency(client.monthlyDebts)}
                </span>
              </div>
            </div>

            <div className="flex flex-col" data-id="element-41">
              <span className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-42">
                Max Affordability
              </span>
              <div className="flex items-center gap-2" data-id="element-43">
                <span className="font-bold text-green-600" data-id="element-44">
                  {formatCurrency(client.monthlyIncome * 0.43 - client.monthlyDebts)}
                  /mo
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}